import _ from 'lodash';

export const getDashboardFlags = (dashboards, outside, plugin, wallmode) => {
  const hasAkbBoards = !!_.find(dashboards, d => !!d.akbBoardId && d.akbBoardId !== 'false');
  const hasNormalBoards = !!_.find(dashboards, d => !d.akbBoardId || d.akbBoardId === 'false');
  const isOutside = outside && !!plugin;
  const isJiraPlugin = plugin && plugin.app === 'jira';
  const akbBoardId = outside && !!plugin && plugin.aid;
  const pluginBoardId = outside && !!plugin && plugin.boardId;
  const pluginDashboardId = outside && !!plugin && plugin.dashboardId;
  const showDropDown = (!isOutside && !pluginBoardId && !pluginDashboardId || isJiraPlugin) && !akbBoardId && !wallmode;

  return {
    hasAkbBoards,
    hasNormalBoards,
    isOutside,
    isJiraPlugin,
    akbBoardId,
    pluginBoardId,
    pluginDashboardId,
    showDropDown
  };
};

export const isOnlyDashboard = (app, searchParams) => {
  return searchParams ? app === 'trello' && searchParams && searchParams.includes('no-dashboard=true'): false;
};

export const filterDashboards = (dashboards, query, boardType) => {
  const searchTerm = query.toLowerCase();
  return dashboards.filter(dashboard => {
    const name = (dashboard.name || '').toLowerCase();
    const label = (dashboard.label || '').toLowerCase();
    const matchesSearch = name.includes(searchTerm) || label.includes(searchTerm);
    
    if (boardType === 'normal') {
      return matchesSearch && (!dashboard.akbBoardId || dashboard.akbBoardId === 'false');
    }
    if (boardType === 'akb') {
      return matchesSearch && (!!dashboard.akbBoardId && dashboard.akbBoardId !== 'false');
    }
    return matchesSearch;
  });
};
